









































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ProductSupplyMix } from '~/mixins';

@Component
export default class ProductSupply extends Mixins(ProductSupplyMix) {
  @Prop({ type: Boolean, default: false }) chipSupply!: boolean;
  @Prop({ type: Boolean, default: false }) chipStoreTotal!: boolean;
  @Prop({ type: Boolean, default: true }) showStoreTotal!: boolean;
  @Prop({ type: Boolean, default: false }) hideAll!: boolean;
  @Prop({ type: Boolean, default: false }) hideStoreTotal!: boolean;
}
